import React, { useState, useEffect } from 'react'
import Assessment from './assessment'
import ConfigCheck from '../../../../components/ConfigCheck'
import moment from 'moment'
import Timer from 'components/Timer'
import { useDispatch, useSelector } from 'react-redux' // Import useDispatch
import { fetchCommunicationInstructions as fetchInstructions } from '../../actions'


// import Modal from 'modules/Events/Preview/Partials/PreviewBox/Modal'

import {
  PageContainer,
  ContentWrapper,
  Header,
  Title,
  TakeButton,
  AssessmentDetails,
  AssessmentName,
  InstructionDeadlineLabel,
  InstructionDeadlineInfo,
  InstructionTimeLeft,
  InstructionDateTime,
  InstructionTime,
  List,
  ListItem,
  StartButton,
  SectionTitle,
  InstructionSection,
  InstructionText,
  BackButton,
  ButtonGroup,
  InstructionDeadlineSection
} from '../../Style'

const CommunicationInstructions = ({
  assessment,
  questions,
  totalQuestions,
  error,
  responses,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchCommunicationInstructions,
  setAssessment 
}) => {
  const [showConfig, setShowConfig] = useState(false)
  const [allChecksComplete, setAllChecksComplete] = useState(false)
  // const assessment = location.state?.assessmentData
  const [isTimerActive, setIsTimerActive] = useState(false)
  const [timerPhase, setTimerPhase] = useState('initial')
  const [countdown, setCountdown] = useState(null)
  const [showAssessment, setShowAssessment] = useState(false)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch() // Add this line to get dispatch
  const instructions = useSelector(state => state.assessment.currentAssessment?.instructions || '')

  useEffect(() => {
    if (assessment?.assessment_set_id) {
      fetchAssessmentQuestions(assessment.assessment_set_id)
      dispatch(fetchInstructions(assessment.assessment_set_id))  // Use renamed import
    }
  }, [assessment?.assessment_set_id, fetchAssessmentQuestions, dispatch])


  const handleTakeAssessment = () => {
    setShowConfig(true)
  }

  const handleBack = () => {
    console.log('Back button clicked');
    setAssessment(null);
  }

    const formatDate = (dateTime) => {
      if (!dateTime) return ''
      return moment(dateTime).format('DD/MM/YYYY')
    }
  
    const formatTime = (dateTime) => {
      if (!dateTime) return ''
      return moment(dateTime).format('hh:mm A')
    }
  
    const calculateDaysLeft = (endTime) => {
      if (!endTime) return ''
      const now = moment()
      const end = moment(endTime)
      const days = end.diff(now, 'days')
      return `${days} days left`
  }

  const handleStart = () => {
    if (!allChecksComplete) return

    setIsTimerActive(true)
    setShowConfig(false) // Add this line to hide config check
    setTimerPhase('initial')

    // Phase 1: Show "Timer starts now" for 2 seconds
    setTimeout(() => {
      setTimerPhase('countdown')
      setCountdown(3)

      // Phase 2: Start countdown
      const countdownInterval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval)
            setTimerPhase('start')

            // Phase 3: Show Start! and begin assessment
            setTimeout(() => {
              setShowAssessment(true)
            }, 1000)

            return 0
          }
          return prev - 1
        })
      }, 1000)
    }, 2000)
  }
  // if (loading) {
  //   return <LoadingSpinner />
  // }

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false)
  //   }, 2000)
  // }, [])

  if (showAssessment) {
    return (
      <Assessment
        questions={questions}
        totalQuestions={totalQuestions}
        loading={loading}
        error={error}
        responses={responses}
        saveQuestionResponse={saveQuestionResponse}
        startTime={new Date()}
      />
    )
  }

  return (
    <PageContainer>
      <ContentWrapper>
      <Header>
  <Title>Communication Assessment</Title>
  {!showConfig && !isTimerActive && (
    <ButtonGroup>
      <BackButton onClick={handleBack}>Back</BackButton>
      <TakeButton onClick={handleTakeAssessment}>Take Assmt.</TakeButton>
    </ButtonGroup>
  )}
</Header>

        {isTimerActive ? (
          <Timer timerPhase={timerPhase} countdown={countdown} />
        ) : (
          <>
           
                       <AssessmentDetails>
                         <AssessmentName>
                           Assessment Name : {assessment?.title || 'Communication Assessment'}
                         </AssessmentName>
                         <InstructionDeadlineSection>
                           <InstructionDeadlineLabel>Deadline</InstructionDeadlineLabel>
                           <InstructionDeadlineInfo>
                             <InstructionTimeLeft>{calculateDaysLeft(assessment?.endTime)}</InstructionTimeLeft>
                             <InstructionDateTime>{formatDate(assessment?.endTime)}</InstructionDateTime>
                             <InstructionTime>{formatTime(assessment?.endTime)}</InstructionTime>
                           </InstructionDeadlineInfo>
                         </InstructionDeadlineSection>
                       </AssessmentDetails>

            {showConfig ? (
              <>
                <ConfigCheck
                  onAllChecksComplete={() => setAllChecksComplete(true)}
                />
                <StartButton
                  allChecksComplete={allChecksComplete}
                  onClick={handleStart}
                  disabled={!allChecksComplete}
                >
                  Start Assessment
                </StartButton>
              </>
            ) : (
              <>
    {/* <InstructionSection>
      <div 
        dangerouslySetInnerHTML={{ __html: instructions }} 
      />
    </InstructionSection> */}

                <InstructionSection>
                  <SectionTitle>Proctoring Instructions</SectionTitle>

                  <List>
                    <ListItem>
                      <strong>Technical Setup</strong>
                      <List>
                        <ListItem>
                          Ensure a stable internet connection.
                        </ListItem>
                        <ListItem>
                          Use a laptop/desktop equipped with a working webcam,
                          microphone, and speakers.
                        </ListItem>
                      </List>
                    </ListItem>

                    <ListItem>
                      <strong>Environment</strong>
                      <List>
                        <ListItem>
                          Sit in a well-lit, quiet environment with minimal
                          background noise.
                        </ListItem>
                        <ListItem>
                          Avoid any distractions or interruptions during the
                          assessment.
                        </ListItem>
                      </List>
                    </ListItem>

                    <ListItem>
                      <strong>Behavior</strong>
                      <List>
                        <ListItem>
                          Do not switch tabs or use unauthorized resources.
                        </ListItem>
                        <ListItem>
                          Stay focused and remain within the assessment
                          interface throughout the session.
                        </ListItem>
                      </List>
                    </ListItem>

                    <ListItem>
                      <strong>Monitoring</strong>
                      <List>
                        <ListItem>
                          The system will monitor your screen, webcam,
                          microphone, and audio for proctoring purposes.
                        </ListItem>
                        <ListItem>
                          Ensure you are visibly present throughout the
                          assessment.
                        </ListItem>
                      </List>
                    </ListItem>

                    <ListItem>
                      <strong>Prohibited Items</strong>
                      <List>
                        <ListItem>
                          Headphones, mobile phones, or any external resources
                          (e.g., notes, books) are strictly prohibited.
                        </ListItem>
                      </List>
                    </ListItem>

                    <ListItem>
                      <strong>Support</strong>
                      <List>
                        <ListItem>
                          In case of technical issues, contact the support team
                          immediately using the provided details.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                </InstructionSection>
              </>
            )}
          </>
        )}
      </ContentWrapper>
    </PageContainer>
  )
}

export default CommunicationInstructions
